import { from as observableFrom, Observable } from "rxjs";

import { debounceTime } from "rxjs/operators";
/* Angular Component */
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from "@angular/core";
import { iDropdownComponent } from "../iDropdown/iDropdown.component";
import { Router } from "@angular/router";
import { MediaInfo, MediaLinkedType, MediaType } from "../../../domain/media";
import { MediaRepository } from "../../../domain/media-repository";
import { Tag } from "../../../domain/tag";
import { TagRepository } from "../../../domain/tag-repository";
import { UserService } from "../../../domain/user-service";
import { InputComponent } from "../input/input.component";

import libraryStore from "../../../services/stores/library.store";
import { IndicateStatus } from "../../../domain/enums";
import { Country } from "../../../domain/country";
import { DropdownSelection } from "../_dropdown/dropdown.component";
import { DropdownItemComponent } from "../_dropdown/dropdown-item.component";
import { CountryService } from "../../../domain/country-service";
import { UI } from "../../../services/ui.service";
import { ToastrService } from "ngx-toastr";
import { RectangleFViewModel } from "../rectangle-f/rectangle-f.view-model";
import { RectangleF } from "../../../domain/rectangle-f";
import { MediaSegmentsViewModel } from "../../mediaEditor/media-segments/media-segments.view-model";
import { ChannelRepository } from "../../../domain/channel-repository";
import { ReportsService } from "../../../services/reports.service";
import {
  MediaQCWorkflowObjective,
  MediaQCWorkflowObjectiveStatus,
} from "app/js/src/domain/qc-workflow";

// TODO: When directive will be ready, implement the following: https://github.com/angular/angular/pull/11235

interface ITab {
  title: string;
  enabled: boolean;
}

@Component({
  selector: "tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent {
  readonly QCC_CONTROLS_HEIGHT = 6;

  libraryStore = libraryStore;
  @Input()
  backgroundColor;

  @Input("media-qc-workflow-objectives-changed")
  mediaQCWorkflowObjectivesChanged: boolean;

  @Input()
  tabs: ITab[] = [];

  @Input()
  mediaSegmentsViewModel: MediaSegmentsViewModel;

  @Output()
  output = new EventEmitter();

  @Input()
  activeTab = 0;

  @Input()
  markBoxStyle;

  @Input()
  media: MediaInfo;

  @Input()
  videoSize: { height: number; width: number };

  @ViewChild("tenantMediaIdInput") tenantMediaIdInput: InputComponent;

  // @Output()

  assetTypeOptions = [
    {
      title: "Video",
    },
    {
      title: "Ads",
    },
    {
      title: "Graphic",
    },
  ];

  dayPartOptions = [];

  countries = [];
  countriesItems: Country[] = [];
  availableCountries = [];
  MediaQCWorkflowObjectiveStatusOptions = [
    {
      name: "Not Checked",
      value: MediaQCWorkflowObjectiveStatus.NotChecked,
    },
    {
      name: "Failed",
      value: MediaQCWorkflowObjectiveStatus.Failed,
    },
    {
      name: "Passed",
      value: MediaQCWorkflowObjectiveStatus.Passed,
    },
  ];
  availableTags = [];

  mediaQCWorkflowObjectivesvm: MediaQCWorkflowObjective[] = [];

  generatingQCObjectives = false;

  titles = [
    "Custom Video Setup:",
    "",
    "Segments:",
    "Attach Files to this Video:",
  ];

  title;

  readonly METADATA_LANG_ALL = "ALL";
  metadataLanguage = "ALL";
  metadataLanguageCodes: string[] = [];
  metadataLanguageDropdownItems: { title: string; value: string }[] = [
    { title: "ALL", value: "ALL" },
  ];

  userMetadata: [{ id: number; name: string }];

  url = "/scheduler/calendar";

  tenantMediaIdUniqueStatus: "fail" | "ok" | "analyzing" = "ok";
  tenantMediaIdInputTouched = false;
  timecodeEditorType: "MS" | "FPS" = "FPS";
  _canSave = false;

  public get enabledTabs(): ITab[] {
    return this.tabs.filter((t) => !!t.enabled);
  }

  @Input()
  floatingMediaPositionRectangleVM: RectangleFViewModel;

  constructor(
    private ref: ElementRef,
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private mediaRepository: MediaRepository,
    private tagRepository: TagRepository,
    private changeDetectorRef: ChangeDetectorRef,
    private countryService: CountryService,
    private ui: UI,
    private toastr: ToastrService,
    private _channelRepository: ChannelRepository,
    private _reportsService: ReportsService,
  ) {}

  done = false;
  saving = false; // Saving indicator (Should be align to tenantMediaIdUniqueStats)

  /**
   * Initializing the component
   * @return void
   */
  async ngOnInit() {
    this.ref.nativeElement.querySelector("nav").style.backgroundColor =
      this.backgroundColor;

    this.title = this.titles[this.activeTab];

    /* Booting dropdown */
    this.bootDropdown();

    const currentChannel = await this.userService.getCurrentChannel();
    if (currentChannel.framerate) {
      this.timecodeEditorType = "FPS";
    } else {
      this.timecodeEditorType = "MS";
    }
    /* Booting tags */
    this.availableCountries = this.userService.getCurrentUser().countries;

    this.availableTags = this.tagRepository.getGeneralTags();

    // this.applyDropdownChanges();

    this.userMetadata = this.userService.getCurrentUser().metadata;
    this.refreshMetadataLanguageState();
    setTimeout(() => this.subscribeUniqueIdValidator(), 200);
  }

  subscribeUniqueIdValidator() {
    const debouncedTenantMediaIdInput = observableFrom(
      this.tenantMediaIdInput.output,
    ).pipe(debounceTime(500));
    const self = this;

    debouncedTenantMediaIdInput.subscribe((tenantMediaId: string) => {
      if (!tenantMediaId) {
        this.tenantMediaIdUniqueStatus = "ok";
        return;
      }

      const mediaId = self.media.id;
      this.mediaRepository
        .isTenantMediaIdUnique(tenantMediaId, mediaId)
        .then((uniqueIdStatus) => {
          // check it is still same media and tenantMediaId
          if (
            self.media.id !== mediaId ||
            self.media.tenantMediaId !== tenantMediaId
          ) {
            return;
          }
          if (uniqueIdStatus === 0) {
            this.ui.notify(this.ui.EVENTS.ShowConfirm, {
              title: "Merge with contract",
              message:
                "do you want to merge this with the contract with the same custom id?",
              buttons: [
                {
                  title: "Yes",
                  callback: () => {
                    this.onMergeConfirm();
                  },
                },
                {
                  title: "No",
                  callback: () => {
                    this.onMergeDeny();
                  },
                },
              ],
            });
          } else {
            self.tenantMediaIdUniqueStatus =
              uniqueIdStatus === 1
                ? (self.tenantMediaIdUniqueStatus = "ok")
                : (self.tenantMediaIdUniqueStatus = "fail");
          }
          this.canSave();

          this.changeDetectorRef.markForCheck();
        });
    });
  }

  onMergeDeny() {
    this.tenantMediaIdUniqueStatus = "fail";
  }

  onMergeConfirm() {
    this.tenantMediaIdUniqueStatus = "ok";
  }

  /**
   * Assign Options to Dropdowns
   * @return void
   */
  bootDropdown() {
    this.dayPartOptions = iDropdownComponent.mapObjectToDropdown(
      "name",
      this.tagRepository.getDayPartingTags(),
    );

    this.assetTypeOptions = iDropdownComponent.mapObjectToDropdown(
      "name",
      this.tagRepository.getAssetTypeTags(),
    );
  }

  ngOnChanges(changes) {
    if (changes["media"] && !!changes["media"]["currentValue"]) {
      this.media = changes["media"]["currentValue"];
      this.updateQCCMarkBox();
      this.applyDropdownChanges();
      this.countries = this.media.mediaLicenseCountryIds;
      this.mediaQCWorkflowObjectivesvm = JSON.parse(
        JSON.stringify(this.media.mediaQCWorkflowObjectives),
      );
      this.prepareSelectedCountries();
      this.canSave();
    }
    if (changes["mediaQCWorkflowObjectivesChanged"] && this.media) {
      this.mediaQCWorkflowObjectivesvm = JSON.parse(
        JSON.stringify(this.media.mediaQCWorkflowObjectives),
      );
      this.generatingQCObjectives = false;
    }
  }

  /**
   * Applying Dropdown Changes
   * @return void
   */
  applyDropdownChanges() {
    /*const mediaTagIds = this.media.mediaTags.map(r => r.id);
        const assetTags = this.tagRepository.getAssetTypeTags().filter(tag => mediaTagIds.indexOf(tag.id) > -1);
        const dayPartingTags = this.tagRepository.getDayPartingTags().filter(tag => mediaTagIds.indexOf(tag.id) > -1);
        //const generalTags = this.tagRepository.getGeneralTags().filter(tag => mediaTagIds.indexOf(tag.id) > -1);
*/
    this.media["AssetType"] = iDropdownComponent.mapObjectToDropdown(
      "name",
      this.media.assetTypes,
    );
    this.media["DaypartType"] = iDropdownComponent.mapObjectToDropdown(
      "name",
      this.media.dayParting,
    );
    this.tenantMediaIdUniqueStatus = "ok";
    this.tenantMediaIdInputTouched = false;

    //this.tags = generalTags;
  }

  onTabClick(tab: ITab) {
    this.activeTab = this.tabs.indexOf(
      this.tabs.find((t) => t.title == tab.title),
    );

    /* Updating Title */
    this.title = this.titles[this.activeTab];
  }

  isTabSelected(tab: ITab): boolean {
    const tabIndex = this.tabs.indexOf(
      this.tabs.find((t) => t.title == tab.title),
    );
    return this.activeTab === tabIndex;
  }

  addNewTag(tag) {
    if (this.media.tags.indexOf(tag) < 0) {
      this.media.tags.push(tag);
    }
  }

  /**
   * Creating new general tag according to supplied tag name
   * @param tagName
   * @return void
   */
  createNewTag(tag) {
    if (tag.trim() === "") {
      return;
    }
    this.tagRepository
      .CreateGeneralTag(tag)
      .then(
        ((response) => {
          /* Updating UI */

          /* Updating Tags */
          if (
            this.media.tags.findIndex((tag) => tag.id === response.id) === -1
          ) {
            this.media.tags.push(response);
          }
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        }).bind(this),
        ((error) => {}).bind(this),
      )
      .catch(((error) => {}).bind(this));
  }

  /**
   * Deleting Exist Tag
   * @return void
   */
  deleteExistTag(tag) {
    this.media.tags.forEach(
      ((savedTag, index) => {
        if (savedTag.id == tag.id) {
          this.media.tags.splice(index, 1);
        }
      }).bind(this),
    );
  }

  /**
   * On Country Select
   * @param countries
   * @return void
   */
  onCountrySelect(selection: DropdownSelection) {
    const countries = selection.values;

    /* prepare array of ids */
    const ids = [];

    /* looking for "all" id */
    const isAllSelected = countries.find((country) => {
      return country === 0;
    });

    /* adding all countries to output array */
    if (isAllSelected === 0) {
      if (countries.length < this.availableCountries.length + 1) {
        this.availableCountries.forEach((country: Country) => {
          ids.push(country.id);
        });
      }
    } else {
      countries.forEach((selectedCountry) => {
        console.log(
          "Adding ",
          selectedCountry,
          " with ID: ",
          selectedCountry.id,
        );
        if (selectedCountry) {
          ids.push(selectedCountry);
        }
      });
    }

    // this.countriesItems = selection.items;
    console.log("IDS: ", this.countriesItems);

    /* set countries to selected values */
    this.countries = ids;

    /* set values in media object */
    this.media.mediaLicenseCountryIds = this.countries;

    this.prepareSelectedCountries();
  }

  /**
   * Preparing selected countries
   * @return void
   */
  prepareSelectedCountries() {
    if (
      this.countries &&
      this.countries instanceof Array &&
      this.countries.length > 0
    ) {
      this.countriesItems = this.countryService.getCountriesByIds(
        this.countries,
      );
    }
  }

  /**
   * Updating Media Name
   * @param value
   */
  setMediaName(value) {
    this.media.name = value;
    this.output.emit({
      key: "name",
      value: value,
    });
  }

  /**
   * Set Video ID
   * @param value
   * @return void
   */
  setVideoID(value) {}

  /**
   * Setting Media Description
   * @param value
   */
  setMediaDesc(value) {
    this.media.description = value;
    this.output.emit({
      key: "description",
      value: value,
    });
  }

  /**
   * On Assign Type Change
   * @param value
   * @return void
   */
  setAssetType(value) {
    const ids = [];

    value.data.forEach(function (item) {
      if (item.model) {
        ids.push(item.model.id);
      }
    });

    this.media.assetTypes = this.tagRepository
      .getAssetTypeTags()
      .filter((t) => ids.includes(t.id));
  }

  /**
   * Set Dayparting Value
   * @param value
   * @return void
   */
  setDayparting(value) {
    if (value.data.length == 0) {
      return;
    }

    this.media.dayParting = [value.data[0].model];
  }

  setVideoId(value) {
    this.media.tenantMediaId = value;
    this.tenantMediaIdUniqueStatus = "analyzing";
    this.tenantMediaIdInputTouched = true;
  }

  /**
   * Return Callback for Saving
   * @returns {any}
   */
  onSave() {
    return function () {
      if (!this.canSave()) {
        return;
      }

      /* Rising the saving flag */
      this.saving = true;

      /* Prepare General Tags */
      //const tagIds = this.tags.map(tag => tag.id);

      /* Assign Tags */
      /*const assetTags = this.tagRepository.getAssetTypeTags().filter(tag => this.media.assetTypes.indexOf(tag.id) > -1);
          const dayPartingTags = this.tagRepository.getDayPartingTags().filter(tag => this.media.dayParting.indexOf(tag.id) > -1);
            this.media.mediaTags = dayPartingTags.concat(assetTags, this.media.mediaTags);*/
      this.media.segments = this.mediaSegmentsViewModel.toSegments();
      /* Prepare Countries */
      // this.media.mediaLicenseCountryIds = this.countries;
      const mediaQCWorkflowBeforeSave = JSON.parse(
        JSON.stringify(this.media.mediaQCWorkflowObjectives),
      );
      this.mediaQCWorkflowObjectivesvm.forEach((objective) => {
        const existingObjective = this.media.mediaQCWorkflowObjectives.find(
          (o) => o.objectiveId === objective.objectiveId,
        );
        if (
          existingObjective &&
          existingObjective.status !== objective.status
        ) {
          existingObjective.previousStatus = existingObjective.status;
          existingObjective.status = objective.status;
          existingObjective.updatedDate = Date.now();
          existingObjective.userId = this.userService.getCurrentUser().username;
        }
      });

      this.mediaRepository
        .update(this.media)
        .then((response) => {
          return this._channelRepository.updatePlaylistBy([this.media.id]);
        })
        .then(
          (response) => {
            this.saving = false;
            //this.router.navigate(['/scheduler/calendar']);
            this.toastr.success("Item has been saved!");
            if (
              this.media.mediaQCWorkflowObjectives.every(
                (x) => x.status === MediaQCWorkflowObjectiveStatus.Passed,
              )
            ) {
              this.media.mediaQCWorkflowObjectives.map(
                (x) =>
                  (x.previousStatus = MediaQCWorkflowObjectiveStatus.Passed),
              );
            } else if (
              this.media.mediaQCWorkflowObjectives.every(
                (x) =>
                  x.previousStatus === MediaQCWorkflowObjectiveStatus.Passed,
              )
            ) {
              this.media.mediaQCWorkflowObjectives.map((x) => {
                if (
                  x.previousStatus === MediaQCWorkflowObjectiveStatus.Passed
                ) {
                  x.previousStatus = x.status;
                }
              });
            }
            this.mediaQCWorkflowObjectivesvm = JSON.parse(
              JSON.stringify(this.media.mediaQCWorkflowObjectives),
            ) as MediaQCWorkflowObjective[];
          },
          (error) => {
            this.saving = false;
            this.media.mediaQCWorkflowObjectives = mediaQCWorkflowBeforeSave;
          },
        )
        .catch((error) => {
          this.saving = false;
          this.media.mediaQCWorkflowObjectives = mediaQCWorkflowBeforeSave;
        });
    }.bind(this);
  }

  onFrameFormatChanged(values) {
    this.media.frameFormat = values;
  }
  /**
   * Reset settings (cancel)
   * @return {any}
   */
  reset() {
    return function () {
      this.router.navigate([this.url], { queryParamsHandling: "preserve" });
    }.bind(this);
  }

  getTenantMediaIdAnalyzingStatus() {
    switch (this.tenantMediaIdUniqueStatus) {
      case "ok":
        return IndicateStatus.Success;
      case "fail":
        return IndicateStatus.Failed;
      case "analyzing":
        return IndicateStatus.Loading;
    }
  }

  canSave() {
    let hasDuplicateLangInAudios = false;
    let existingLang = "";

    if (this.media.audioFiles) {
      const existingLangsDictionary = {};

      for (let i = 0; i < this.media.audioFiles.length; i++) {
        const audio = this.media.audioFiles[i];
        if (audio && audio.language && audio.language.length > 0) {
          if (existingLangsDictionary[audio.language]) {
            existingLang = audio.language;
            hasDuplicateLangInAudios = true;
            break;
          } else {
            existingLangsDictionary[audio.language] = true;
          }
        }
      }
    }
    if (hasDuplicateLangInAudios) {
      this.toastr.error(
        `Cannot save the media item. Duplicated audio language ${existingLang} detected!`,
      );
    }
    this._canSave =
      this.tenantMediaIdUniqueStatus === "ok" &&
      !this.saving &&
      this.media &&
      this.media.tenantMediaId &&
      this.media.tenantMediaId.length > 0 &&
      hasDuplicateLangInAudios === false;
    return this._canSave;
  }

  onMetadataLanguageChanged(lang) {
    this.metadataLanguage = lang;
  }

  private static readonly ISO_639_1_CODES = new Set([
    "AA","AB","AE","AF","AK","AM","AN","AR","AS","AV","AY","AZ",
    "BA","BE","BG","BH","BI","BM","BN","BO","BR","BS",
    "CA","CE","CH","CO","CR","CS","CU","CV","CY",
    "DA","DE","DV","DZ",
    "EE","EL","EN","EO","ES","ET","EU",
    "FA","FF","FI","FJ","FO","FR","FY",
    "GA","GD","GL","GN","GU","GV",
    "HA","HE","HI","HO","HR","HT","HU","HY",
    "HZ","IA","ID","IE","IG","II","IK","IO","IS","IT","IU",
    "JA","JV",
    "KA","KG","KI","KJ","KK","KL","KM","KN","KO","KR","KS","KU","KV","KW","KY",
    "LA","LB","LG","LI","LN","LO","LT","LU","LV",
    "MG","MH","MI","MK","ML","MN","MR","MS","MT","MY",
    "NA","NB","ND","NE","NG","NL","NN","NO","NR","NV","NY",
    "OC","OJ","OM","OR","OS",
    "PA","PI","PL","PS","PT",
    "QU",
    "RM","RN","RO","RU","RW",
    "SA","SC","SD","SE","SG","SI","SK","SL","SM","SN","SO","SQ","SR","SS","ST","SU","SV","SW",
    "TA","TE","TG","TH","TI","TK","TL","TN","TO","TR","TS","TT","TW","TY",
    "UG","UK","UR","UZ",
    "VA","VE","VI","VO",
    "WA","WO",
    "XH",
    "YI","YO",
    "ZA","ZH","ZU",
  ]);

  private refreshMetadataLanguageState() {
    const langRegex = /_([A-Za-z]{2})$/;
    const codeSet = new Set<string>();
    if (this.userMetadata) {
      this.userMetadata.forEach((item) => {
        const match = item.name.match(langRegex);
        if (match) {
          const code = match[1].toUpperCase();
          if (TabsComponent.ISO_639_1_CODES.has(code)) {
            codeSet.add(code);
          }
        }
      });
    }
    this.metadataLanguageCodes = Array.from(codeSet).sort();
    this.metadataLanguageDropdownItems = [
      { title: this.METADATA_LANG_ALL, value: this.METADATA_LANG_ALL },
      ...this.metadataLanguageCodes.map((code) => ({ title: code, value: code })),
    ];
    if (
      this.metadataLanguage !== this.METADATA_LANG_ALL &&
      !this.metadataLanguageCodes.includes(this.metadataLanguage)
    ) {
      this.metadataLanguage = this.METADATA_LANG_ALL;
    }
  }

  private metadataRowVisibleForFilter(name: string): boolean {
    if (this.metadataLanguage === this.METADATA_LANG_ALL) {
      return true;
    }
    const suffix = `_${this.metadataLanguage}`;
    return name.toUpperCase().endsWith(suffix.toUpperCase());
  }

  get visibleMetadataIndices(): number[] {
    if (!this.userMetadata) {
      return [];
    }
    return this.userMetadata.reduce<number[]>((acc, item, i) => {
      if (this.metadataRowVisibleForFilter(item.name)) {
        acc.push(i);
      }
      return acc;
    }, []);
  }

  metadataValue(index) {
    if (this.media) {
      for (let i = 0; i < this.media.metadata.length; i++) {
        if (this.media.metadata[i].id === this.userMetadata[index].id) {
          return this.media.metadata[i].value;
        }
      }
    }
    return "";
  }

  setMetadataValue(event, index) {
    for (let i = 0; i < this.media.metadata.length; i++) {
      if (this.media.metadata[i].id === this.userMetadata[index].id) {
        this.media.metadata[i]["value"] = event;
        return;
      }
    }
    this.media.metadata.push({ id: this.userMetadata[index].id, value: event });
  }

  updateQCCMarkBox() {
    console.log("updateQCCMarkBox -> ", this.media.cropSettings);
    if (
      this.markBoxStyle &&
      this.media &&
      this.media.cropSettings &&
      this.validateCropFields()
    ) {
      const videoQccBoxAspectRatio =
        this.videoSize.width / this.videoSize.height;
      const mediaAspectRation = this.media.getAspectRation();

      let pillarBoxOffset = 0;
      let letterBoxOffset = 0;
      let currentMediaQccVideoHeight = this.videoSize.height;
      let currentMediaQccVideoWidth = this.videoSize.width;

      if (videoQccBoxAspectRatio - mediaAspectRation > 0) {
        currentMediaQccVideoWidth =
          this.videoSize.height * this.media.getAspectRation();
        pillarBoxOffset =
          (this.videoSize.width - currentMediaQccVideoWidth) / 2;
      }

      if (videoQccBoxAspectRatio - mediaAspectRation < 0) {
        currentMediaQccVideoHeight =
          this.videoSize.width / this.media.getAspectRation();
        letterBoxOffset =
          (this.videoSize.height - currentMediaQccVideoHeight) / 2;
      }

      console.log(
        "updateQCCMarkBox -> 1 ",
        currentMediaQccVideoHeight,
        currentMediaQccVideoWidth,
        this.media.getAspectRation(),
        pillarBoxOffset,
        letterBoxOffset,
      );

      this.markBoxStyle["padding-left"] =
        (
          pillarBoxOffset +
          (currentMediaQccVideoWidth * this.media.cropSettings.left) / 100
        ).toString() + "px";
      this.markBoxStyle["padding-right"] =
        (
          pillarBoxOffset +
          (currentMediaQccVideoWidth * this.media.cropSettings.right) / 100
        ).toString() + "px";
      this.markBoxStyle["padding-top"] =
        (
          letterBoxOffset +
          (currentMediaQccVideoHeight * this.media.cropSettings.top) / 100
        ).toString() + "px";
      this.markBoxStyle["padding-bottom"] =
        (
          letterBoxOffset +
          (currentMediaQccVideoHeight * this.media.cropSettings.bottom) / 100
        ).toString() + "px";
    } else {
      console.log("updateQCCMarkBox -> ", this.markBoxStyle, this.media);
    }
  }

  private validateCropFields() {
    return this.calculateRightMax() >= 0 && this.calculateLeftMax() >= 0;
  }

  calculateLeftMax() {
    if (this.media && this.media.cropSettings) {
      const result = 99 - this.media.cropSettings.right;
      return result;
    }
    return 50;
  }

  showToastr(message: string) {
    this.toastr.success(message);
  }

  calculateRightMax() {
    if (this.media && this.media.cropSettings) {
      const result = 99 - this.media.cropSettings.left;
      return result;
    }
    return 50;
  }

  getAllTagNames() {
    return this.availableTags
      .map((x) => x.name)
      .filter((v, i, a) => a.indexOf(v) === i);
  }

  downloadMediaUsageReport() {
    this._reportsService.getMediaUsageReport(this.media.id);
    return false;
  }

  addQCWorkflowObjective() {
    if (this.generatingQCObjectives) {
      return;
    }
    this.generatingQCObjectives = true;
    this.output.emit({
      key: "addQCWorkflowObjective",
      value: this.media.id,
    });
  }

  onQCWorkflowObjectiveStatusChange(objectiveId: number, event: Event) {
    console.log("onQCWorkflowObjectiveStatusChange -> ", event);
    const status = (event.target as HTMLSelectElement).value;
    const objective = this.mediaQCWorkflowObjectivesvm.find(
      (o) => o.objectiveId === objectiveId,
    );
    if (objective) {
      objective.status = Number(status);
    }
  }
  getQCStatusTabDotColor() {
    if (this.media.mediaQCWorkflowObjectives.length === 0) {
      return "transparent";
    }
    if (
      this.media.mediaQCWorkflowObjectives.some(
        (o) => o.status === MediaQCWorkflowObjectiveStatus.Failed,
      )
    ) {
      return "#B22222";
    }
    if (
      this.media.mediaQCWorkflowObjectives.some(
        (o) => o.status === MediaQCWorkflowObjectiveStatus.NotChecked,
      )
    ) {
      return "#FFC72C";
    }
    return "#2E8B57";
  }
}
